import React, { useEffect } from "react";


import {
  FaGlobe,
  FaLaptopCode,
  FaShieldAlt,
  FaThumbsUp,
  FaUniversalAccess,
  FaLightbulb,
  FaChartLine,
  FaAward,
} from "react-icons/fa";

const items = [
  { icon: <FaGlobe />, title: "Digital" },
  { icon: <FaLaptopCode />, title: "Tecnológico" },
  { icon: <FaShieldAlt />, title: "Seguro" },
  { icon: <FaThumbsUp />, title: "Prático" },
  { icon: <FaUniversalAccess />, title: "Acessível" },
  { icon: <FaLightbulb />, title: "Disruptivo" },
  { icon: <FaChartLine />, title: "Moderno" },
  { icon: <FaAward />, title: "Exclusivo" },
];

export const WhyChooseUs = () => {
  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,           // viewport
      rootMargin: '0px',    // sem margem
      threshold: 0          // dispara quando qualquer parte entra
    }
  );

  const elements = document.querySelectorAll(".reveal");
  elements.forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}, []);




  return (
    <section className="why-choose-us">
      <h2 className="title reveal">PORQUE NOS ESCOLHER? <span>POR QUE SOMOS!</span></h2>

      <div className="why-cards-container">
        {items.map((item, index) => (
          <div key={index} className="why-card reveal">
            <div className="why-icon">{item.icon}</div>
            <p className="why-title">{item.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
